module.exports = __webpack_public_path__ + "media/src/StayPackage/images/checkGreen-ed26db6c1650f79b7762dc5565505348.svg";